import { checkResolution } from '../functions/helpers';

function toggleSwiperTabIndex(swiperInstance) {
    const slides = swiperInstance.slides
    const itemsCount = swiperInstance.params.slidesPerView

    for (const slide of slides) {
        for (const tabbable of slide.querySelectorAll('a, button')) {
            tabbable.tabIndex = checkResolution('cxs;xs') ? 0 : -1
        }
    }

    if (!checkResolution('cxs;xs')) {
        const tabbableSlides = [...slides].reduce((accumulator, current) => {
            if (current.classList.contains('swiper-slide-active') || (accumulator.length && accumulator.length < itemsCount)) {
                accumulator.push(current)
            }

            return accumulator
        }, [])

        for (const slide of tabbableSlides) {
            for (const tabbable of slide.querySelectorAll('a, button')) {
                tabbable.tabIndex = 0
            }
        }
    }
}

const paginationOptions = (instance) => ({
    pagination: {
        el: instance.paginationEl,
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 15,
        hideOnClick: false,
    }
})

const navigationOptions = (instance) => ({
    navigation: {
        prevEl: instance.prevEl,
        nextEl: instance.nextEl,
        disabledClass: 'is-disabled',
        hiddenClass: 'is-hidden'
    }
})

const indexSliderOptions = (instance) => {
    instance.customNavTexts = [...instance.querySelectorAll('[data-custom-nav-text]')].map(el => el.dataset.customNavText)
    instance.isAnimatable = false

    return {
        effect: 'fade',
        followFinger: false,
        speed: 500,
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: document.querySelector('.js-index-banner-pagination'),
            bulletClass: 'c-btn--pagination',
            bulletActiveClass: 'is-active',
            renderBullet: function (index, className) {
                return `
                    <button class="c-btn ${className}" type="button" data-slide-index="${index}">
                        ${instance.customNavTexts[index]}
                    </button>
                `
            }
        },
        on: {
            init(swiper) {
                requestAnimationFrame(() => {
                    document.querySelectorAll('.js-index-banner-pagination .c-btn').forEach(button => {
                        button.addEventListener('click', event => {
                            swiper.slideTo(event.target.dataset.slideIndex)
                        })
                    })
                })
            },
            slideChange(swiper) {
                if (!instance.isAnimatable) {
                    swiper.slides.forEach(slide => slide.classList.add('is-animatable'))

                    instance.isAnimatable = true
                }
            }
        }
    }
}

const productSliderOptions = (instance) => {
    let breakpoints = {
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            cssMode: false
        },
        1280: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            cssMode: false
        }
    }

    if (instance.classList.contains('is-index-products-slider') && !document.querySelector('[r-slider-index-banner]')) {
        breakpoints = {
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                cssMode: false
            },
            1280: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                cssMode: false
            }
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        cssMode: true,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            hideOnClick: false,
        },
        breakpoints: breakpoints,
        on: {
            init(swiper) {
                toggleSwiperTabIndex(swiper)
            },
            slideChangeTransitionEnd(swiper) {
                toggleSwiperTabIndex(swiper)
            },
            breakpoint(swiper) {
                toggleSwiperTabIndex(swiper)
            }
        }
    }
}

const mostOrderedOptions = (instance) => ({
    slidesPerColumn: 5,
    slidesPerColumnFill: 'row'
})

const indexBenefitsOptions = (instance) => ({
    cssMode: true
})

const manufacturersListOptions = (instance) => ({
    cssMode: true,
    slidesPerView: 'auto'
})

const options = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        roundLengths: true,
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexSliderOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        options = {...options, ...productSliderOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-most-ordered')) {
        options = {...options, ...mostOrderedOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-index-benefits')) {
        options = {...options, ...indexBenefitsOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-manufacturers-list')) {
        options = {...options, ...manufacturersListOptions(instance)}
    }

    return {...options, ...instance.customOptions}
}

export default options